module.exports = __webpack_public_path__ + "static/media/NewOrderBig.8b872e6b.svg";